<script setup lang="ts">
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    // SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubItem,
    SidebarMenuSubButton,
    SidebarRail,
} from "@/components/ui/sidebar"
import { ChevronRight, Globe, Home, SquareArrowOutUpRight } from "lucide-vue-next";
import { useSidebar } from "@/components/ui/sidebar"
import { currentWebsite } from '@partner-spa-vue/stores/MyWebsitesStore';
import {
    checkStripeAccountReady,
    currentMarketingStripeStatus,
    currentSupportStripeStatus
} from '@partner-spa-vue/stores/CurrentWebsiteStripeStatusStore';

const { setOpenMobile } = useSidebar()

</script>
<template>
    <Sidebar variant="sidebar"
             collapsible="offcanvas">
        <div class="bg-card min-h-full flex flex-col">
            <SidebarHeader>
                <SidebarMenu>
                    <SidebarMenuItem class="flex items-center gap-2 text-sm text-muted-foreground">
                        <RouterLink :to="{ name: 'home' }">
                            <Home class="h-5 w-5" />
                        </RouterLink>
                        <ChevronRight class="h-5 w-5" />
                        <RouterLink :to="{ name: 'my-websites' }"
                                    class="flex items-center gap-2 text-sm text-muted-foreground">
                            My Websites
                        </RouterLink>
                    </SidebarMenuItem>
                    <SidebarMenuItem>
                        <RouterLink :to="{ name: 'website-home' }"
                                    @click="setOpenMobile(false)">
                            <SidebarMenuButton size="lg"
                                               class="">
                                <div class="flex aspect-square size-8 items-center justify-center rounded-lg">
                                    <Globe class="size-8" />
                                </div>
                                <div class="grid flex-1 text-left text-sm leading-tight">
                                    <span class="truncate font-semibold">
                                        {{ currentWebsite?.name }}
                                    </span>
                                    <span class="truncate text-xs">
                                        {{ currentWebsite?.defaultHostname ?? '❌Domain required' }}
                                    </span>
                                </div>
                            </SidebarMenuButton>
                        </RouterLink>

                    </SidebarMenuItem>

                    <SidebarMenuItem>
                        <SidebarMenuButton size="lg"
                                           as="a"
                                           :href="`https://${currentWebsite?.defaultHostname}`"
                                           target="_blank">
                            <div class="flex aspect-square size-8 items-center justify-center rounded-lg">
                                <SquareArrowOutUpRight class="size-8" />
                            </div>
                            <div class="grid flex-1 text-left text-sm leading-tight">
                                <span class="truncate font-semibold">
                                    Open website
                                </span>
                            </div>
                        </SidebarMenuButton>
                    </SidebarMenuItem>

                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent>
                <SidebarGroup>
                    <!-- <SidebarGroupLabel>Setup</SidebarGroupLabel> -->
                    <SidebarMenu>

                        <SidebarMenuItem>
                            <RouterLink :to="{ name: 'website-address' }"
                                        @click="setOpenMobile(false)">
                                <SidebarMenuButton>
                                    Partner Directory Address
                                </SidebarMenuButton>
                            </RouterLink>
                        </SidebarMenuItem>


                        <SidebarMenuItem>
                            <RouterLink :to="{ name: 'support-earnings' }"
                                        @click="setOpenMobile(false)">
                                <SidebarMenuButton>
                                    Support Partnership
                                </SidebarMenuButton>
                            </RouterLink>
                            <SidebarMenuSub>
                                <SidebarMenuSubItem>
                                    <SidebarMenuSubButton as-child>
                                        <RouterLink :to="{ name: 'support-earnings' }"
                                                    @click="setOpenMobile(false)">
                                            Overview
                                        </RouterLink>
                                    </SidebarMenuSubButton>
                                </SidebarMenuSubItem>

                                <div v-if="currentWebsite?.isSupportTeamPartner">
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-stripe' }"
                                                        @click="setOpenMobile(false)">
                                                <!-- Business and bank details -->
                                                Stripe
                                                {{ checkStripeAccountReady(currentSupportStripeStatus) === false ? '⚠️' : '' }}
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-fee-settings' }"
                                                        @click="setOpenMobile(false)">
                                                Fee Settings
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-balances' }"
                                                        @click="setOpenMobile(false)">
                                                Balances
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-incoming' }"
                                                        @click="setOpenMobile(false)">
                                                Incoming
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-unpaid' }"
                                                        @click="setOpenMobile(false)">
                                                Unpaid
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-history' }"
                                                        @click="setOpenMobile(false)">
                                                History
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-reports' }"
                                                        @click="setOpenMobile(false)">
                                                Reports
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-notifications' }"
                                                        @click="setOpenMobile(false)">
                                                Notifications
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'support-earnings-imprint' }"
                                                        @click="setOpenMobile(false)">
                                                Imprint
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                </div>
                            </SidebarMenuSub>
                        </SidebarMenuItem>

                        <SidebarMenuItem>
                            <RouterLink :to="{ name: 'marketing-earnings' }"
                                        @click="setOpenMobile(false)">
                                <SidebarMenuButton>
                                    Affiliate Partnership
                                </SidebarMenuButton>
                            </RouterLink>
                            <SidebarMenuSub>
                                <SidebarMenuSubItem>
                                    <SidebarMenuSubButton as-child>
                                        <RouterLink :to="{ name: 'marketing-earnings' }"
                                                    @click="setOpenMobile(false)">
                                            Overview
                                        </RouterLink>
                                    </SidebarMenuSubButton>
                                </SidebarMenuSubItem>

                                <div v-if="currentWebsite?.isMarketingTeamPartner">
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-stripe' }"
                                                        @click="setOpenMobile(false)">
                                                <!-- Business and bank details -->
                                                Stripe
                                                {{ checkStripeAccountReady(currentMarketingStripeStatus) === false ? '⚠️' : '' }}
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-fee-settings' }"
                                                        @click="setOpenMobile(false)">
                                                Fee Settings
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-balances' }"
                                                        @click="setOpenMobile(false)">
                                                Balances
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-incoming' }"
                                                        @click="setOpenMobile(false)">
                                                Incoming
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-unpaid' }"
                                                        @click="setOpenMobile(false)">
                                                Unpaid
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-history' }"
                                                        @click="setOpenMobile(false)">
                                                History
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-reports' }"
                                                        @click="setOpenMobile(false)">
                                                Reports
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                    <SidebarMenuSubItem>
                                        <SidebarMenuSubButton as-child>
                                            <RouterLink :to="{ name: 'marketing-earnings-notifications' }"
                                                        @click="setOpenMobile(false)">
                                                Notifications
                                            </RouterLink>
                                        </SidebarMenuSubButton>
                                    </SidebarMenuSubItem>
                                </div>
                            </SidebarMenuSub>
                        </SidebarMenuItem>

                    </SidebarMenu>
                </SidebarGroup>
            </SidebarContent>
            <SidebarFooter>
                <!-- footer -->
            </SidebarFooter>
            <SidebarRail />
        </div>
    </Sidebar>
</template>